import { render, staticRenderFns } from "./TransmissionsSendNotification.vue?vue&type=template&id=1af4d89d&"
import script from "./TransmissionsSendNotification.vue?vue&type=script&lang=js&"
export * from "./TransmissionsSendNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports